import React from "react";
import { Calendar, Clock, CheckCircle, ArrowRight } from "lucide-react";
import { mockTimeline } from "../data/mock";

const Timeline = () => {
  return (
    <section id="timeline" className="py-20" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <div className="hero-announcement mb-6">
            <Clock size={12} style={{ color: 'var(--accent-blue-400)' }} />
            <span>IMPLEMENTATION TIMELINE</span>
          </div>
          <h2 className="heading-1 mb-4">
            From Planning to 
            <span style={{ color: 'var(--accent-green-200)' }}> Deployment in 30 Days</span>
          </h2>
          <p className="body-large" style={{ 
            maxWidth: '700px', 
            margin: '0 auto',
            color: 'var(--text-primary)',
            fontWeight: '500'
          }}>
            Our structured implementation process ensures smooth deployment of your AI agent system.
            <strong> Clear milestones and transparent communication throughout.</strong>
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {mockTimeline.map((week, index) => (
            <div key={index} className="mb-12 last:mb-0">
              <div className="flex flex-col lg:flex-row gap-8 items-start">
                <div className="lg:w-64 flex-shrink-0">
                  <div className="flex items-center gap-3 mb-4">
                    <div 
                      className="w-12 h-12 rounded-full flex items-center justify-center font-mono font-semibold"
                      style={{ 
                        background: week.color,
                        color: 'var(--text-primary)' 
                      }}
                    >
                      {week.week}
                    </div>
                    <div>
                      <h3 className="heading-3">{week.title}</h3>
                      <div className="caption">{week.duration}</div>
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <p className="body-medium mb-6" style={{ color: 'var(--text-secondary)' }}>
                    {week.description}
                  </p>
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    {week.activities.map((activity, activityIndex) => (
                      <div 
                        key={activityIndex}
                        className="flex items-start gap-3 p-4 rounded-lg hover-lift"
                        style={{ background: 'var(--bg-card)' }}
                      >
                        <CheckCircle size={16} style={{ color: 'var(--accent-green-200)' }} className="mt-1 flex-shrink-0" />
                        <div>
                          <div className="body-small font-medium mb-1">
                            {activity.name}
                          </div>
                          <div className="caption">
                            {activity.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              {index < mockTimeline.length - 1 && (
                <div className="flex justify-center my-8">
                  <ArrowRight size={24} style={{ color: 'var(--border-light)' }} />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="inline-flex items-center gap-4 p-6 rounded-lg hover-lift" style={{ 
            background: 'var(--bg-card)',
            border: '2px solid var(--accent-blue-400)'
          }}>
            <Calendar size={24} style={{ color: 'var(--accent-blue-400)' }} />
            <div className="text-left">
              <div className="body-medium font-semibold mb-1" style={{ color: 'var(--accent-blue-400)' }}>
                Ready to Get Started?
              </div>
              <div className="body-small" style={{ color: 'var(--text-secondary)' }}>
                Schedule a consultation to discuss your implementation timeline
              </div>
            </div>
            <button className="btn-primary hover-scale">
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;